import { render } from "./NewPerson.vue?vue&type=template&id=55dc0448&scoped=true"
import script from "./NewPerson.vue?vue&type=script&lang=js"
export * from "./NewPerson.vue?vue&type=script&lang=js"

import "./NewPerson.vue?vue&type=style&index=0&id=55dc0448&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dc0448"]])

export default __exports__